// extracted by mini-css-extract-plugin
export default {"edmHeader":"src-constrains-DraggableModules-ContentGroup-EDM-css__edmHeader--uLBLY","body":"src-constrains-DraggableModules-ContentGroup-EDM-css__body--MikgB"};